module.exports = __webpack_public_path__ + "img/peru.44a090fc.svg";